import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BundlesListComponent } from './bundles-list/bundles-list.component';
import { BundleComponent } from './bundle/bundle.component';
import { BatchComponent } from './batch/batch.component';
import { AddBundlesComponent } from './add-bundles/add-bundles.component';
import { DraftBatchComponent } from './draft-batch/draft-batch.component';

const routes: Routes = [
    { 
        path: '',
        component: BundlesListComponent
    },
    { path: 'add', component: AddBundlesComponent, title: 'routes.addBundle', data: { breadcrumb: { label: 'Add', url: 'add' } } },
    { path: ':bundleID', component: BundleComponent, title: 'routes.bundle', data: { breadcrumb: { label: 'Bundle', url: '00000000-0000-0000-0000-000000000000' } } },
    { path: ':bundleID/draft-batch/:batchID', component: DraftBatchComponent, title: 'routes.draftBatch', data: { breadcrumb: { label: 'Batch', url: '00000000-0000-0000-0000-000000000000/draft-batch/00000000-0000-0000-0000-000000000000' } } },
    { path: ':bundleID/batches/:batchID', component: BatchComponent, title: 'routes.batch', data: { breadcrumb: { label: 'Batch', url: '00000000-0000-0000-0000-000000000000/batches/00000000-0000-0000-0000-000000000000' } } }
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class BundlesRoutingModule { }